import React from 'react'
import './Title.css'

const Title = ({subTitle, title, className = '', style = {}}) => {
  return (
    <div className={`title ${className}`} style={style}>
        <p style={{textAlign:"center"}}>{subTitle}</p>
        <h2>{title}</h2>
    </div>
  )
}

export default Title
